<script>
    import HealthDec from "./HealthDec.svelte"
    import {
        apiUrl,
        token,
        decMade,
        cloudant_id,
        corp_id,
        corp_name,
        corp_uname,
        name,
        sex,
        age,
        residence,
        cellphone,
        idNumber,
        department,
        soreThroat,
        bodyPains,
        headache,
        fever,
        covidContact,
        supsectContact,
        travelAbroad,
        travelCity,
        triage,
        triageDesc,
        time,
        temp,
        addQuestionsAns
    } from "../store.js"
    import axios from "axios"
    import Loader from "./Loader.svelte"
    import { onMount } from "svelte";

    let isLoading, isError, isDecMade = false
    if ($decMade === 'true') {
        isDecMade = true
    }
    let parsedQuestionsAns = JSON.parse($addQuestionsAns)
    let myQuestionsAns = (parsedQuestionsAns) ? parsedQuestionsAns : null
    let submit = async function () {
        isLoading = true
        let url
        let headers = { "X-IBM-Client-Id": process.env.CLOUD_KEY }
        let data = { 
            "personData": {
                "name": $name,
                "sex": $sex,
                "age": $age,
                "residence": $residence,
                "cellphone": $cellphone,
                "idNumber": $idNumber,
                "department": $department
            },
            "symptomData": {
                "soreThroat": $soreThroat,
                "bodyPains": $bodyPains,
                "headache": $headache,
                "fever": $fever,
                "covidContact": $covidContact,
                "suspectContact": $supsectContact,
                "travelAbroad": $travelAbroad,
                "travelCity": $travelCity,
                "triage": $triage,
                "triageDesc": $triageDesc
            },
            "orgData": {
                "cloudant_id": $cloudant_id,
                "corp_id": $corp_id,
                "corp_name": $corp_name,
                "corp_uname": $corp_uname
            },
            "addtlQuestions": myQuestionsAns
         }
         if($token !== '') {
             url = `${apiUrl}/submit-health-dec-token`
             data.token = $token
         } else {
             url = `${apiUrl}/submit-health-dec-temp`
             data.temp = $temp
         }
        try {
            let req = await axios.post(url, data, {headers: headers})
            isLoading = false
            console.log(req.data)
            temp.set(req.data.temp)
            let myTime = new Date(req.data.timestamp)
            const options = { weekday: "short", year: "numeric", month: "short", day: "numeric", hour12: true };
            const created = myTime.toLocaleTimeString("en-PH", options)
            time.set(created)
            decMade.set('true')
            isLoading = false
            isError = false
        } catch(e) {
            alert(e)
            isLoading = false
            isError = true
            if (e.response.data) {
                console.log(e.response.data)
            }
        }
    }

    onMount(() => {
        if (!isDecMade) {
            submit()
        } else {
            isLoading = false
            isError = false
        }
    })
</script>

<main>
    {#if isLoading}
    <Loader/>
    {/if}

    {#if !isLoading && !isError}
    <div class="qrBody">
        <HealthDec/>
    </div>
    {/if}

    {#if !isLoading && isError}
    <div class="body">
        <h1>We encountered an error. Please try again.</h1>
        <a class="btn btn-primary" on:click={submit}>Try Again</a>
    </div>
    {/if}
</main>

<style>
.qrBody {
    margin-top: 54px;
}
</style>